/* JS fallback for the entry wrapper.

   PRIMARY APPROACH: editors insert two HTML cards per entry — an opening
   `<article class="op-entry op-entry--split-left op-entry--print">` card and a
   closing `</article>` card. If Ghost's HTML pipeline preserves the orphan
   tags, the article wraps the cards naturally and this script does nothing.

   FALLBACK: if Ghost's sanitizer auto-closes the orphan <article> in the
   opening card (so the wrapper trick fails), the editor instead uses marker
   divs:
     <div class="op-entry-start" data-variant="split-left" data-kind="print"></div>
     ...cards...
     <div class="op-entry-end"></div>
   This script wraps the siblings between markers in the proper <article>.
*/
(function () {
  var starts = document.querySelectorAll('.op-entry-start');
  if (!starts.length) return;

  starts.forEach(function (start) {
    var article = document.createElement('article');
    var variant = start.getAttribute('data-variant') || 'split-left';
    var kind    = start.getAttribute('data-kind')    || 'print';
    article.className = 'op-entry op-entry--' + variant + ' op-entry--' + kind;

    var node = start.nextSibling;
    while (node) {
      var isEnd = node.nodeType === 1
        && node.classList
        && node.classList.contains('op-entry-end');
      if (isEnd) break;
      var next = node.nextSibling;
      article.appendChild(node);
      node = next;
    }

    start.parentNode.insertBefore(article, start);
    start.remove();
    if (node) node.remove();
  });
})();
